import { isNull } from 'lodash';
import * as yup from 'yup';

export const scheduleMeetingValidationSchema = yup.object().shape({
  teamId: yup.number().required(),
  scheduleDate: yup.date().nullable().required(),
  meetingIsRecurring: yup.bool(),
  recurringDueDate: yup
    .date()
    .nullable()
    .when(['meetingIsRecurring', 'scheduleDate'], {
      is: (meetingIsRecurring, scheduleDate) =>
        meetingIsRecurring && !isNull(scheduleDate),
      then: yup
        .date('Please select valid recurring end date.')
        .nullable()
        .required('Please select recurring end date.')
    }),
  topic: yup.string().max(255, 'Topic name is too long'),
  notes: yup.string(),
  agendaUrl: yup.string().url()
});

export const addExampleValidationSchema = yup.object().shape({
  attribution: yup.string().required('Name of Source Required'),
  url: yup.string().required('Link to Source Required')
});

export const regularSignupValidationSchema = yup.object().shape({
  email: yup.string().email('Email is invalid.').required('Email is required.'),
  password: yup.string().required('Password is required.')
});

export const personalGoalsValidationSchema = yup.object().shape({
  mainGoal: yup.string().required('Main goal is required.'),
  soThat: yup.string().required('This field is required.'),
  successWillLookLike: yup.string().required('This field is required.')
});

export const addAgendaDialogValidationSchema = yup.object().shape({
  url: yup.string().url()
});

export const meetingInvitationValidationSchema = yup.object().shape({
  preferredUserName: yup.string().trim().required('Name is required.'),
  schoolId: yup.number().nullable()
});

export const phoneInputValidationSchema = yup.object().shape({
  preferredUserName: yup.string().trim().required('Name is required.'),
  stateAbbreviation: yup.string().required('State is required.'),
  schoolId: yup.number().nullable(),
  organization: yup.string().when('schoolId', {
    is: (schoolId) => isNull(schoolId),
    then: yup.string().required('Please enter organization.')
  }),
  city: yup
    .string()
    .trim()
    .when('schoolId', {
      is: (schoolId) => isNull(schoolId),
      then: yup.string().required('Please select city.')
    }),
  phoneNumber: yup
    .string()
    .when('schoolId', {
      is: (schoolId) => !isNull(schoolId),
      then: yup.string().required('Please enter phone number.')
    })
    .min(11, 'Phone number is too short')
});

export const signUpWithPasswordValidationSchema = yup.object().shape({
  firstName: yup.string().nullable(),
  lastName: yup.string(),
  email: yup.string().nullable().email(),
  password: yup
    .string()
    .min(8, 'Password should contain at least 8 characters')
    .matches('[A-Za-z]+', 'Password should contain at least one letter')
});

export const teacherSignUpValidationSchema = yup.object().shape({
  firstName: yup.string().nullable(),
  lastName: yup.string(),
  email: yup.string().nullable().email(),
  password: yup
    .string()
    .min(8, 'Password should contain at least 8 characters')
    .matches('[A-Za-z]+', 'Password should contain at least one letter')
});
